<template>
  <modal :active="active" @close="handleCloseModal">
    <div v-if="actionType == 'createModal'" slot="title">
      Create New Cluster
    </div>
    <div v-else slot="title">Update Cluster</div>
    <div class="col-12" style="display: flex; justify-content: end">
      <div
        style="display: flex; align-items: center; justify-content: center"
        class="col-5"
      >
        <div v-if="!cluster_image" class="image-upload">
          <media-browser
            v-model="cluster_image"
            :active="showMediaBrowserModal"
            filterBy="images"
            @closeRequest="toggleMediaBrowserModal"
          ></media-browser>
          <i
            @click="toggleMediaBrowserModal"
            style="font-size: 170px"
            class="fa fa-image"
          ></i>
        </div>
        <div
          v-else
          style="display: flex; flex-direction: column; align-items: center"
        >
          <img
            :src="
              'data:image/' +
              cluster_image.extension +
              ';base64,' +
              cluster_image.image
            "
            alt=""
          />
          <div style="margin-top: 15px">
            <button
              style="
                border-radius: 30px;
                padding-top: 0px;
                padding-left: 7px;
                padding-right: 7px;
                padding-bottom: 0px;
              "
              @click="removeClusterImage()"
              type="button"
              class="btn btn-danger"
            >
              <i style="font-size: 12px" class="fa fa-trash"></i>
              Remove
            </button>
          </div>
        </div>
      </div>
      <div class="col-7">
        <div
          v-if="actionType == 'updateModal'"
          class="col-12"
          style="margin-top: 10px"
        >
          <label>Code: {{ code }}</label>
        </div>
        <div class="col-12">
          <label>Name</label>
          <input class="form-control" type="text" required v-model="name" />
        </div>
        <div class="col-12" style="margin-top: 10px">
          <label>Description</label>
          <textarea
            class="form-control"
            type="text"
            required
            v-model="description"
          />
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" class="btn btn-danger" @click="init()">
        Reset
      </button>
      <button type="button" class="btn btn-success" @click="handleSave()">
        Save
      </button>
    </div>
  </modal>
</template> 
 <script>
import Spinner from "vue-simple-spinner";
import Modal from "../../../../components/Modal.vue";
import ClusterStorer from "../../../../storers/StoreCluster";
import MediaBrowser from "../../../common/MediaBrowser.vue";
import ClustersFilter from "../../../../filters/ClustersFilter";
import { mapState } from "vuex";
export default {
  data() {
    return {
      code: null,
      name: null,
      description: null,
      cluster_image: null,
      clusterImagePreview: null,
      showMediaBrowserModal: false,
    };
  },
  props: {
    active: Boolean,
    actionType: String,
    activeCluster: Object,
  },
  components: { Spinner, Modal, MediaBrowser },
  created: function () {},
  computed: {
    ...mapState({
      clustersCount: (state) => state.clusterStore.clusterSearch.clustersCount,
    }),
  },
  methods: {
    init() {
      this.code = null;
      this.name = null;
      this.description = null;
      this.cluster_image = null;
    },

    removeClusterImage() {
      this.cluster_image = null;
    },
    fillForm() {
      this.code = this.activeCluster.code;
      this.name = this.activeCluster.name;
      this.description = this.activeCluster.description;
      this.cluster_image = this.activeCluster.cluster_image;
    },
    handleCloseModal() {
      this.$emit("closeRequest");
    },
    toggleMediaBrowserModal() {
      this.showMediaBrowserModal = !this.showMediaBrowserModal;
    },
    handleSave() {
      var cluster = ClusterStorer();
      if (this.actionType == "updateModal") {
        cluster.id = this.activeCluster.id;
        cluster.code = this.activeCluster.code;
      }
      cluster.name = this.name;
      cluster.description = this.description;
      if (this.cluster_image) {
        cluster.media_id = this.cluster_image.id;
      }
      this.$emit("saveRequest", cluster);
    },
  },
  watch: {
    actionType() {
      this.init();
      if (this.actionType == "updateModal") {
        this.fillForm();
      }
    },
    active() {
      if (this.active && !this.code) {
        var clustersFilter = ClustersFilter();
        this.$store.dispatch("searchClusters", {
          filter: clustersFilter,
          resultMode: "count",
        });
      }
    },
  },
};
</script> 
 <style>
.image-upload > input {
  display: none;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/modals/clusterModal.vue